/**
 * Cold start with the game unreachable (API down, 500, no signal): not Sign in, because nobody was signed out.
 * What happened, what is safe, what to do. The session retries on its own (lib/session.tsx).
 */
import { useState, type ReactElement } from "react";
import { Button, Screen } from "../components";
import { useSession } from "../lib/session";

export function UnreachableScreen(): ReactElement {
  const { refresh } = useSession();
  const [busy, setBusy] = useState(false);
  const again = async () => { setBusy(true); try { await refresh(); } finally { setBusy(false); } };
  return (
    <Screen title="Can't reach DIGU" className="screen--single">
      <div className="content door__missing" data-testid="unreachable" role="alert">
        <h1 className="d-l">Can't reach DIGU</h1>
        <p className="body text-secondary">The game didn't answer. Your account and games are safe. Check your signal and try again; we'll keep trying too.</p>
        <div className="door__actions">
          <Button onClick={() => void again()} busy={busy} id="unreachable-retry">Try again</Button>
        </div>
      </div>
    </Screen>
  );
}
